import { addQueues, modifyQueues, deleteQueues } from 'Actions/index';
import { BaseHandler } from 'WebSocket/Handlers/BaseHandler';
import { SubscriptionTypes } from 'WebSocket/CacheManager/SubscriptionTypes';
import { Queue, Id} from 'NSwag/ServerClient/Client.nswag';
import { Action, Store } from 'redux';

/**
 * Defines a web socket to handle async updates for
 * MqaQueue objects from the API.
 */
export class QueueHandler extends BaseHandler<Queue> {
    /** @inheritdoc */
    subscriptionType: SubscriptionTypes = SubscriptionTypes.QueueStatusWrapper;

    /** @inheritdoc */
    type = Queue;

    /**
     * The current store for this handler.
     */
    store: Store<any, Action>;

    /**
     * Creates a new Handler object
     * @param store - The CacheManager store.
     */
    constructor(store: Store<any, Action>) {
        super();
        this.store = store;
    }

    /**
     * @inheritdoc
     */
    handleAdd = (data: Queue[]) => {
        this.store.dispatch(addQueues(data));
    }

    /**
     * @inheritdoc
     */
    handleModify = (data: Queue[]) => {
        this.store.dispatch(modifyQueues(data));
    }

    /**
     * @inheritdoc
     */
    handleDelete = (data: Id[]) => {
        this.store.dispatch(deleteQueues(data));
    }
}